(function( $ ) {
    if ($('.search-buttons').length > 0) {
        let lang = $('html').attr('lang');
        lang = lang.split('-')
        lang = lang[0]
        $('.search-buttons a').each(function() {
        let href = $(this).attr('href') + '&lang=' + lang;
        $(this).attr('href', href);
        });
    }

    if ($('.search-not-found').length > 0) {
        $('.search-not-found').hide();
    }

    let containers = ['faq','category','page','post','youtube'];
    containers.forEach(container => {
        let limitResults = 3;
        let elements;
        let elementsTwo;
        let elementsThree;

        if (container == 'page') {
          elements = '.search-'+ container +' article.type-'+ container + ', .search-page article.type-e-landing-page';
          elementsTwo = '.search-'+ container +' article.type-'+ container +':hidden, .search-page article.type-e-landing-page:hidden';
          elementsThree = '.search-'+ container +' .type-'+ container + ', .search-page article.type-e-landing-page';
        } else {
          elements = '.search-'+ container +' article.type-'+ container;
          elementsTwo = '.search-'+ container +' article.type-'+ container +':hidden';
          elementsThree = '.search-'+ container +' .type-'+ container;
        }

        if ($('.search-' + container).length > 0) {            
            if ($(elements).length > limitResults) {
                $('.search-' + container + ' .elementor-widget-button').click(function(e) { 
                    $(elementsTwo).slice(0, limitResults).show();
                    //console.log('length' + $('.search-'+ container +' .type-'+ container + ':hidden').length)
                    if ($(elementsTwo).length == 0) {
                      $('.search-' + container + ' .elementor-widget-button').hide();
                    }
                    e.preventDefault();
                });
            } else {
                $('.search-' + container + ' .elementor-widget-button').hide();
            }

            if ($(elementsThree).length > 0) {
                //console.log($('.search-'+ container +' article.type-'+ container +':hidden').length +' '+ limitResults)
                $(elementsTwo).slice(0, limitResults).show();
                //console.log(elementsTwo)
                
            } else {
                $('.search-not-found').first().clone().prependTo($('.search-' + container +' .elementor-widget-wrap:first')).show();
            }            
        } 
    });

    const searchIconSvg = $('.search-icon .elementor-icon').html();
    
    $( document ).on( 'elementor/popup/show', ( event, id, instance ) => {
        $('.search-icon').removeClass('opacity')
        $('.search-popup').removeClass('visible')
        if ($(('.dialog-widget-content .elementor-search-form__input')).length > 0) {
            $('.elementor-search-form__submit').html(searchIconSvg)
            if (!$('.search-icon').hasClass('opacity')) {
                $('.search-icon').addClass('opacity')
                $('.search-popup').addClass('visible')
            }
        }
    });
    
    $( document ).on( 'elementor/popup/hide', ( event, id, instance ) => {
        $('.search-icon').removeClass('opacity')
        $('.search-popup').removeClass('visible')
    });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/search.js